import React, { useEffect, useState } from "react";
import {
  ChangeTitle,
  toAbsoluteUrl,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { apiHeader, getData } from "../../helpers/ApiHelper";
import { ToastContainer } from "react-toastify";
import { IoMdMail } from "react-icons/io";
import { RiWhatsappFill } from "react-icons/ri";

const ReferAndEarn = () => {
  ChangeTitle("Refer And Earn");
  const [reserLink, setReferLink] = useState("");

  // Refer Link API Call
  const viewReferLink = async () => {
    var response = await getData(
      "private/user/referlink",
      {},
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      setReferLink(data.referCode);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewReferLink();
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              Refer and earn
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div>
            <h2 className="w-full text-center mb-[5%] md:mb-[2%] refer-title">
              Introducing the program "refer and earn," where you can get a
              chance to earn  loyalty points for every friend you refer.
            </h2>
            <div className="w-full mb-[5%]">
              <img
                className="mx-auto w-[50%] lg:w-[35%]"
                src={toAbsoluteUrl("media/img/refer/refer.svg")}
                alt=""
              />
            </div>
            <div className="lg:w-[80%] xl:w-[70%] mx-auto">
              <h1 className="refer-title mb-[2rem]">
                Copy your referral link and share it with your friends:
              </h1>
              <div className="w-full flex mb-[3rem] lg:mb-[5rem]">
                <div className="w-[70%] sm:w-[85%]">
                  <h1 className="w-full p-[2rem] lg:p-[3rem] refer-input">
                    {reserLink}
                  </h1>
                </div>
                <div className="w-[30%] sm:w-[15%]">
                  <button
                    type="button"
                    onClick={() => {
                      navigator.clipboard.writeText(reserLink);
                      toastsuccessmsg("Link Copied.");
                    }}
                    className="w-full h-full btn-refer-copy"
                  >
                    Copy link
                  </button>
                </div>
              </div>

              <div className="mx-auto md:mx-0 flex items-center gap-[5%] mb-[2rem]">
                <div className="w-[50%] refer-line"></div>
                <h1 className="refer-line-text">or</h1>
                <div className="w-[50%] refer-line"></div>
              </div>

              <div className="mx-auto flex justify-center items-center sm:flex-row flex-col gap-10 sm:gap-20 mb-[5rem]">
                <a
                  href={`mailto:?subject=Check%20this%20out&body=${encodeURIComponent(
                    reserLink
                  )}`}
                  className="w-max flex items-center gap-4 lg:p-[3rem] p-[2rem] btn-refer-share"
                >
                  <IoMdMail className="btn-refer-share-icon" />
                  <span className="btn-refer-share-text">Share via mail</span>
                </a>
                <a
                  href={`https://wa.me/?text=${reserLink}`}
                  className="w-max flex items-center gap-4 lg:p-[3rem] p-[2rem] btn-refer-share btn-refer-share2"
                >
                  <RiWhatsappFill className="btn-refer-share-icon" />
                  <span className="btn-refer-share-text">
                    Share in whatsApp
                  </span>
                </a>
              </div>
              <div className="lg:w-[80%] mx-auto">
                <h1 className="mb-[2rem] refer-title-b">How it works?</h1>
                <div className="">
                  <div className="flex gap-5 flex-row w-full relative">
                    <div className="relative z-[2] w-1/3">
                      <div className="relative z-[2] flex flex-col gap-5">
                        <div className="w-12 h-12 p-[2rem] lg:p-[3rem] rounded-full flex items-center justify-center mx-auto lg:mx-0 refer-number">
                          1
                        </div>
                        <p className="mt-3 text-center lg:text-start refer-number-text">
                          Invite your friend by sharing your personalized link.
                        </p>
                      </div>
                      <div className="flex absolute z-[1] w-full top-8 lg:top-12 left-[50%] lg:left-10 refer-number-line"></div>
                    </div>
                    <div className="relative z-[2] w-1/3">
                      <div className="relative z-[2] flex flex-col gap-5">
                        <div className="w-12 h-12 p-[2rem] lg:p-[3rem] rounded-full flex items-center justify-center mx-auto lg:mx-0 refer-number">
                          2
                        </div>
                        <p className="mt-3 text-center lg:text-start refer-number-text">
                          Your friend registers on gcclaw.com using the link
                          shared by you.
                        </p>
                      </div>
                      <div className="flex absolute z-[1] w-full top-8 lg:top-12 left-[50%] lg:left-10 refer-number-line"></div>
                    </div>

                    <div className="relative z-[2] w-1/3">
                      <div className="relative z-[2] flex flex-col gap-5">
                        <div className="w-12 h-12 p-[2rem] lg:p-[3rem] rounded-full flex items-center justify-center mx-auto lg:mx-0 refer-number">
                          3
                        </div>
                        <p className="mt-3 text-center lg:text-start refer-number-text">
                          You and your friend get 50 loyalty points.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReferAndEarn;
